import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-image-open-modal',
  standalone:true,
  templateUrl: './image-open-modal.component.html',
  styleUrls: ['./image-open-modal.component.scss']
})
export class ImageOpenModalComponent implements OnInit {
public image = this.data.image
  constructor(
    private _dialogRef: MatDialogRef<ImageOpenModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { image:string },
    private _matDialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
  }

  public onClose() {
    this._dialogRef.close()
  }
}
